__turbopack_context__.v({
  "details": "collapsible-drawer-module-scss-module__Z2anNa__details",
  "summary": "collapsible-drawer-module-scss-module__Z2anNa__summary",
});
